/*
 * @Author: hucaili 735856642@qq.com
 * @Date: 2023-06-09 18:38:04
 * @LastEditors: hucaili 735856642@qq.com
 * @LastEditTime: 2023-06-09 20:19:47
 * @FilePath: \fe-crm\src\store\modules\calllog.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { publicService } from '@/api/';
import { defineStore } from 'pinia';
// import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
export const useCalllogStore = defineStore('getcalllog', {
  state: () => ({}),
  actions: {
    //通话记录
    getOutCallDetail(params) {
      return new Promise((resolve, reject) => {
        publicService
          .getOutCallDetail(params)
          .then((res) => {
            if (res.error) {
              Message.error(res.error?.msg || '操作失败');
            }
            resolve(res);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || '获取数据失败');
            reject(err);
          });
      });
    }
  }
});
export default useCalllogStore;
